// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScanOutlinedSvg from "@fishx/icons-svg/es/asn/ScanOutlined";
import FishxIcon from '../components/FishxIcon';

var ScanOutlined = function ScanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScanOutlinedSvg
  }));
};

ScanOutlined.displayName = 'ScanOutlined';
export default React.forwardRef(ScanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScanOutlined.js
// module id = 4059
// module chunks = 0